"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/General/API/UmbracoApiRequestResult.tsx"/>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var CSVReportService = /** @class */ (function () {
    function CSVReportService() {
        this.baseEndpoint = "/umbraco/api/ipdcsvreportsapi";
    }
    CSVReportService.prototype.GetAllSchemeTraineesReport = function (contactId, currentRole, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallschemetraineesreport?contactId=" + contactId + "&currentRole=" + currentRole + "&email=" + email)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallschemetraineesreport?contactId=" + contactId + "&currentRole=" + currentRole, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_1 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetCaAllTraineesReport = function (trainingSchemeId, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getcaalltraineesreport?trainingSchemeId=" + trainingSchemeId + "&email=" + email)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getcaalltraineesreport?trainingSchemeId=" + trainingSchemeId, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_2 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_2];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetAllSCETraineesReport = function (trainingSchemeId, contactId, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallscetraineesreport?trainingSchemeId=" + trainingSchemeId + "&contactId=" + contactId + "&email=" + email)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallscetraineesreport?trainingSchemeId=" + trainingSchemeId + "&contactId=" + contactId, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_3 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_3];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetAllSchemeTraineesByGroupReport = function (contactId, groupId, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallschemetraineesbygroupreport?contactId=" + contactId + "&groupId=" + groupId + "&email=" + email)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallschemetraineesbygroupreport?contactId=" + contactId + "&groupId=" + groupId, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_4 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_4];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetNonIPDTraineesReport = function (trainingSchemeId, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getnonipdtraineesreport?trainingSchemeId=" + trainingSchemeId + "&email=" + email)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getnonipdtraineesreport?trainingSchemeId=" + trainingSchemeId, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_5 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_5];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.getAppraisalsReport = function (contactId, setLoader) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/Getannualappraisalsreport?contactId=" + contactId, { responseType: 'blob' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_6 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_6];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetPendingTraineesReport = function (trainingSchemeId, setLoader) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getpendingtraineesreport?trainingSchemeId=" + trainingSchemeId, { responseType: 'blob' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_7 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_7];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetAllSCEsReport = function (contactId, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallscesreport?contactId=" + contactId + "&email=" + email)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getallscesreport?contactId=" + contactId, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_8 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_8];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetCAPayments = function (trainingSchemeId, organisationName, setLoader) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getcapayments?trainingSchemeId=" + trainingSchemeId + "&organisationName=" + organisationName, { responseType: 'blob' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_9 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_9];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetIndividualPaymentReport = function (transactionId, trainingSchemeId, organisationName, setLoader) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getindividualpaymentreport?transactionId=" + transactionId + "&trainingSchemeId=" + trainingSchemeId + "&organisationName=" + organisationName, { responseType: 'blob' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_10 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_10];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetCurrentSearchTraineeReport = function (contactId, currentSearch, currentRole, setLoader, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getcurrentsearchtraineereport?contactId=" + contactId + "&currentRole=" + currentRole + "&currentSearch=" + currentSearch + "&email=" + email)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getcurrentsearchtraineereport?contactId=" + contactId + "&currentRole=" + currentRole + "&currentSearch=" + currentSearch, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_11 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_11];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetMDOSearchTraineesReport = function (currentSearch, setLoader) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getmdosearchtraineesreport?currentSearch=" + currentSearch, { responseType: 'blob' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_12 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_12];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CSVReportService.prototype.GetBySchemeTraineesReport = function (contactId, role, trainingSchemeId, setLoader, currentSearch, emailFlag, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!emailFlag) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getbyschemetraineesreport?contactId=" + contactId + "&role=" + role + "&trainingSchemeId=" + trainingSchemeId + "&currentSearch=" + currentSearch + "&email=" + email)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/getbyschemetraineesreport?contactId=" + contactId + "&role=" + role + "&trainingSchemeId=" + trainingSchemeId + "&currentSearch=" + currentSearch, { responseType: 'blob' })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                    case 5:
                        err_13 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, err_13];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return CSVReportService;
}());
exports.default = CSVReportService;
